<template>
    <div>
        <b-overlay :show="loaded" rounded="sm">
        <b-row>
                <div class="mt-5 d-inline-block col-6">
                    <h3 class="mobile-font">{{$translate('scheduling_heading')}}</h3>
                </div>
                <div class="d-flex d-inline-block col-6 align-items-center justify-content-end mt-3">
                    <span class="me-2 mobile-font">{{ $translate('add_schedule') }}</span>
                    <div class="Click-here"></div>
                    <b-button variant="blue-icon" id="add-schedule-btn"  @click=" 
                model = {}
                isModalVisible = true
                " v-b-tooltip.hover :title="$addLabel()"><img src="@/assets/images/icon/gradient-add.svg"></b-button>
        </div>
        </b-row>
        <b-modal v-model="isModalVisible" id="message-modal" hide-footer :close-on-backdrop="false" class="pt-8" centered
            header-class="p-0" footer-class="d-flex justify-content-center border-0" content-class="custom-model-wrap">
            <template #modal-title>
                <div class="title-block text-center p-2 m-0">
                    {{ model.id ? $translate('edit_asset_schedule') : $translate('add_asset_schedule') }}
                </div>
            </template>
            <b-row class="filter-form p-0" v-for="n in 2" :key="n + 'type'" :keyy="n + 'type'">
                    <div v-for="(d_item, i) in formFields[
    n == 1 ? 'evenList' : 'oddList'
  ]" class="col-12 mt-3"
                      :class="{ 'col-md-12': (d_item.field === 'order_template_id' || d_item.field === 'section_scheduling'), 'col-md-8': (d_item.field === 'master_item_id'), 'col-md-2': (d_item.type === 'check'), 'col-md-4': (d_item.type !== 'check') }"
                      :key="`${n} type ${i} group`" :id="d_item.field">
                      <template v-if="d_item.field === 'section_scheduling'">
                        <hr />
                        <h3>{{ $translate(d_item.label) }}</h3>
                      </template>
                      <label v-if="d_item.field !== 'section_scheduling'" :for="'input-' + d_item.field"
                        class="mb-3"><strong>{{
    getLabel(d_item.label)
  }}<span class="red" v-if="d_item.required">*</span></strong>
                      </label>
                      <select-order-template v-if="d_item.field == 'order_template_id'"
                        :assetClass="'form-control'" v-model="model[d_item.field]" :isAsset="true" :toggle-active="false"
                         include-order-type :is-required="crm" />
                   

                      <b-col class="dd" v-else-if="d_item.type === 'select'">
                        <b-form-select class="form-control" :id="'input-' + d_item.field" v-model="model[d_item.field]"
                          :required="d_item.required" v-custom-validation="d_item.required ? $selectRequired() : ''
    " :options="getOptions(d_item.field)" :disabled="is_one_off_linked(d_item.field)">
                          <template #first>
                            <b-form-select-option :value="null" :disabled="d_item.required">
                              {{
    `${$translate("select")} ${getLabel(
      d_item.label
    )}`
  }}
                            </b-form-select-option>
                          </template>
                        </b-form-select>
                      </b-col>


                      <b-form-textarea v-else-if="d_item.type === 'textarea'"
                        :id="'input-' + d_item.field" v-model="model[d_item.field]" :required="d_item.required"
                        v-custom-validation="d_item.required ? $textRequired() : ''
    " :placeholder="`${$translate('enter')} ${getLabel(
    d_item.label
  )}`" rows="3" max-rows="6">
                      </b-form-textarea>
                      <b-form-input :disabled="is_one_off_linked(d_item.field) || (d_item?.disabled || false)" v-else-if="d_item.type !== '' && d_item.label != 'item'"
                        :type="d_item.type" :id="'input-' + d_item.field" v-model="model[d_item.field]"
                        :required="d_item.required" :min="d_item?.min" v-custom-validation="d_item.required ? $textRequired() : ''
    " :placeholder="`${$translate('enter')} ${getLabel(
    d_item.label
  )}`" trim>
                      </b-form-input>
                    </div>
                  </b-row>
           
            <div class="d-flex justify-content-center mt-3">
                <b-button id="add-or-update-schedule-btn"  size="sm" @click="createSchedule" class="btn-fw me-3" 
                     variant="info">{{ model.id
                        ? $translate('update_schedule') : $translate('add_schedule') }}</b-button>
                <b-button id="add-or-update-schedule-close-btn" size="sm" @click="isModalVisible = false" variant="info" class="btn-fw">{{ $translate('close')
                }}</b-button>
            </div>
        </b-modal>
        
        <b-col class="page-block">
            <strong>
                {{ $translate("page") }}: {{ pagination.page }}
                {{ $translate("of") }} {{ pageCount }} {{ $translate("total") }}:
                {{ pagination.total }}
            </strong>
        </b-col>
        
        <b-row>
            <b-col md="12"  class="mobile-table">
                <b-table id="orderTable" :items="assetSchedules" :fields="fields" :per-page="itemsPerPage"
                :current-page="currentPage" :busy="tableLoading" responsive show-empty
                    ref="selectableTable"  >
                    <template #table-busy>
                        <div class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <!-- <strong>{{ $translate('loading') }}</strong> -->
                        </div>
                    </template>
        
                    <template #empty>
                        <p class="text-center m-0">{{ $translate("add_message_note") }}</p>
                    </template>
                    <template #emptyfiltered>
                        <p class="text-center m-0">{{ $translate("add_message_note") }}</p>
                    </template>
        
                    <template #cell(actions)="{ item }">
                        <div class="d-flex">
                            <b-button :id="'view-schedule-item-'+item.id"  @click="viewItem(item)" class="me-2" variant="pink-button">
                                <img src="@/assets/images/icon/view.svg">
                            </b-button>
                            <b-button :id="'delete-schedule-item-'+item.id" variant="pink-button" 
                                @click="deleteSchedule(item.id)"
                                ><img
                                    src="@/assets/images/icon/delete.svg"></b-button>
                        </div>
                    </template>
        
                    <template #cell(id)="{ index }">
                        <p>
                            {{ index + 1 }}
                        </p>
                    </template>
        
                    <template #cell(frequency)="{ value }">
                        <span> {{ getFrequencyType(value) }}</span>
                    </template>
                    <template #cell(service_time_of_day)="{ value }">
                        <span> {{ IntToTimeFormat(value) }}</span>
                    </template>
        
                    <template #cell(created_at)="{ value }">
                        <p>{{ value | displayTime(new Date()) }}</p>
                    </template>
        
                    <template #cell(user_id)="{ item }">
                        <p>
                            {{ displayUser(item.user) }}
                        </p>
                    </template>
                </b-table>
            </b-col>
        </b-row>
     
        <b-row>
            <b-col>
                <b-pagination
                    class="justify-content-center mt-4"
                    v-model="pagination.page"
                    :total-rows="pagination.total"
                    :per-page="pagination.pageSize"
                    aria-controls="customerTable"
                    :prev-text="$translate('previous')"
                    :next-text="$translate('next')"
                    pills
                    align="center"
                ></b-pagination>
            </b-col>
        </b-row>
        </b-overlay>
    </div>
</template>

<script>
// import moment from 'moment'
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'
import assetMixins from "@/mixins/assetMixins";
import utilityMixins from "@/mixins/utilityMixins";
import SelectOrderTemplate from "@/components/SelectOrderTemplate";

const tomorrow_date = new Date().toISOString().split("T")[0];

const dataItems = [
  //mandatory  but must be automated
  {
    field: "name",
    label: "schedule_name",
    type: "text",
    required: true,
  },
  { field: "frequency", label: "frequency", type: "select", required: true },
  { field: "last_service_date", label: "last_service_date", type: "date" },
  {
    field: "next_service_date",
    label: "next_service_date",
    type: "date",
    required: true,
    min: tomorrow_date,
  },
  {
    field: "service_day_of_week",
    label: "service_day_of_week",
    type: "select",
    required: false,
  },
  {
    field: "service_time_of_day",
    label: "service_time_of_day",
    type: "time",
    required: false,
  },
  {
    field: "termination_date",
    label: "termination_date",
    type: "date",
    required: false,
  },
  {
    field: "description",
    label: "description",
    type: "textarea",
    required: false,
  },
  {
    field: "order_template_id",
    label: "activity_template",
    type: "custom",
    required: false,
  },
];

const crm_fields = [
  {
    field: "section_scheduling",
    label: "scheduling_heading",
    type: "",
    required: false,
  },
  {
    field: "name",
    label: "schedule_name",
    type: "text",
    required: true,
  },
  {
    field: "description",
    label: "description",
    type: "textarea",
    required: false,
  },
  { field: "frequency", label: "frequency", type: "select" },
  { field: "last_service_date", label: "last_visit", type: "date" },
  {
    field: "next_service_date",
    label: "next_visit",
    type: "date",
    min: tomorrow_date,
  },
  { field: "service_day_of_week", label: "week_day", type: "select" },
  { field: "service_time_of_day", label: "time_of_day", type: "time" },
  {
    field: "termination_date",
    label: "termination_date",
    type: "date",
    required: false,
  },
  {
    field: "contract_expiry_date",
    label: "exp_date",
    type: "date",
    required: true,
  },
  { field: "order_template_id", label: "activity_templates", required: true },
];

// const generateEmptyForm = () => {
//   return dataItems.reduce(
//     (_form, item) => {
//       _form[item.field] = null;
//       return _form;
//     },
//     { id: 0 }
//   );
// };

// const model = generateEmptyForm();

export default {
    name: 'asset-schedule',
    components: {
        SelectOrderTemplate
    },  
    mixins: [popupMixins, permissionsMixins,assetMixins, utilityMixins],
    data() {
        return {
            model: {service_time_of_day:null},
            isModalVisible: false,
            scheduleCreated: false,
            tableLoading: false,
            submitting: false,
            itemsPerPage: 15,
            currentPage: 1,
            loaded:true,
          
        }
    },
    props: {
        viewMode: { type: Boolean, default: false },
        crm: { type: Boolean, default: false },
        isNew: { type: Boolean, default: false },
        assetId: {
            type: [String, Number], 
            required: true 
        },

    },
    filters: {
        // displayTime(date) {
        //     const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
        //     console.log('timezone', timezone)
        //     if (date) {
        //         return new Date(date).toLocaleString('en-US', {
        //             timeZone: timezone,
        //         })
        //     } else {
        //         return ''
        //     }
        // },
    },
    computed: {
        componentName() {   
            if (this.crm) {
                return this.$translate('crm_schedule');
            } else {
                return this.$translate('asset_schedule');
            } 
        },
        fields() {

            const crmFields = [
               
                {
                    key: 'actions',
                    label: this.$translate('actions'),
                    class: 'actionButton_class',
                },
                {
                    key: 'name',
                    label: this.$translate('schedule_name'),
                   
                },

                {
                    key: 'frequency',
                    label: this.$translate('frequency'),
                    
                },
                {
                    key: 'last_service_date',
                    label: this.$translate('last_visit'),
                   
                },
                {
                    key: 'next_service_date',
                    label: this.$translate('next_visit'),
                   
                },
                {
                    key: 'service_day_of_week',
                    label: this.$translate('service_week_day'),
                    formatter: (value) => this.formatDayOfWeek(value),
                   
                },
                {
                    key: 'service_time_of_day',
                    label: this.$translate('service_time_of_day'),
                   
                },
                {
                    key: 'termination_date',
                    label: this.$translate('termination_date'),
                   
                },
            ]
            if (this.crm) return crmFields
            return [
              
                {
                    key: 'actions',
                    label: this.$translate('actions'),
                    class: 'actionButton_class',
                },
                {
                    key: 'name',
                    label: this.$translate('schedule_name'),
                   
                },

                {
                    key: 'frequency',
                    label: this.$translate('frequency'),
                    
                },
                {
                    key: 'last_service_date',
                    label: this.$translate('last_service_date'),
                   
                },
                {
                    key: 'next_service_date',
                    label: this.$translate('next_service_date'),
                   
                },
                {
                    key: 'service_day_of_week',
                    label: this.$translate('service_week_day'),
                    formatter: (value) => this.formatDayOfWeek(value),
                   
                },
                {
                    key: 'service_time_of_day',
                    label: this.$translate('service_time_of_day'),
                   
                },
                {
                    key: 'termination_date',
                    label: this.$translate('termination_date'),
                   
                },
                
            ]
        },
       

        assetSchedules() {
            console.log('data----------', this.$store.state.assetScheduleStore.assetSchedules)
            return this.$store.state.assetScheduleStore.assetSchedules
        },
    
        tomorrowDate() {
            const today = new Date();
            const tomorrow = new Date(today);
            tomorrow.setDate(tomorrow.getDate() + 1);
            // Format the date to 'YYYY-MM-DD' format
            const year = tomorrow.getFullYear();
            const month = String(tomorrow.getMonth() + 1).padStart(2, '0');
            const day = String(tomorrow.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        },
        formFields() {
            const list = [];
            if (this.crm) {
                console.log('field- no')
                for (const crm_obj of crm_fields) {
                const obj = dataItems.find((y) => y.field == crm_obj.field);
                if(obj){
                    for (const key in crm_obj) {
                        this.$set(obj, key, crm_obj[key]);
                    }
                    list.push(obj);
                }
                }
            } else {
                list.push(...dataItems);
                console.log('field- yes', list)
            }
            // split in odd and even
            const typeObj = { oddList: [], evenList: [] };
            let isEven = true;
            for (const item of list) {
                // if (isEven) {
                //     typeObj.evenList.push(item)
                // } else {
                // }
                typeObj.oddList.push(item);
                isEven = !isEven;
            }
            return typeObj;
        },
        pageCount() {
            return Math.ceil(this.pagination.total / this.pagination.pageSize);
        },
        pagination() {
            return this.$store.state.assetScheduleStore.pagination || { page: 1 };
        },
        crmSettingValue() {
      return this.$store.getters["company/crmSettingValue"];
        },
    },
    watch: {
        // 'assetSchedules': {
        //     handler: function (schedules) {
        //         this.$store.dispatch('assetScheduleStore/load', schedules)
        //     },
        //     deep: true,
        // },
        'model.frequency': function (val) {

            if (val.frequency == "0") {
                const { next_service_date: nsd } = this.model;
                const weekday = new Date(nsd).getDay();
                this.$set(this.model, "service_day_of_week", weekday);
            }
        },

        'model.next_service_date': function (val) {

            if (this.model.frequency == "0") {
                const weekday = new Date(val).getDay();
                this.$set(this.model, "service_day_of_week", weekday);
            }
        },
       
       "pagination.page": function (val) {
            console.log('page-----',val)
            this.doSearch();
        },
    },
    async mounted() {
        // const { notes } = this.order
        // const schedule_data = this.assetSchedules
        // this.scheduleCreated = false
        // this.$store.dispatch('assetScheduleStore/load', schedule_data || [])
        this.doSearch();
       
    },
    methods: {
        IntToTimeFormat(intValue) {
            const formatInt = (_int) => {
                if (_int < 10) _int = `0${_int}`;
                else _int = _int.toString();
                return _int;
            };
            let hours = parseInt(intValue / 60, 10);
            if (hours > 23 || hours < 0) hours = 0;
            let minutes = intValue - hours * 60;

            return `${formatInt(hours)}:${formatInt(minutes)}`;
        },
        is_one_off_linked(key) {
            const checkKeys = [
                "last_service_date",
                "contract_expiry_date",
                "service_day_of_week",
            ];
            const isIncluded = (key) => {
                const _is_included = checkKeys.includes(key);
                console.log({ key, _is_included });
                return _is_included;
            };
            return this.model.frequency == "0" && isIncluded(key);
        },
        getLabel(value) {
            const label =
                value == "task_title"
                ? this.crm
                    ? this.$translate("task_title")
                    : this.$translate("name")
                : this.$translate(value);
            return label;
        },
        displayUser(user) {
            if (user) {
                const name = user.first_name + ' ' + user.last_name
                return (user.is_customer_user ? this.$translate('client') : this.$translate('agent')) + ':' + name
            } else {
                return this.$translate('self')
            }
        },
        viewItem(item) {
            this.model = { ...item }
            // for (const key in item) {
            //     this.$set(this.model, key, item[key])
            // }
            this.$set(
                this.model,
                "service_time_of_day",
                this.IntToTimeFormat(item.service_time_of_day)
            );
            this.isModalVisible = true
        },
        formatDate(date) {
            var hours = date.getHours()
            var minutes = date.getMinutes()
            var ampm = hours >= 12 ? 'pm' : 'am'
            hours = hours % 12
            hours = hours ? hours : 12 // the hour '0' should be '12'
            minutes = minutes < 10 ? '0' + minutes : minutes
            var strTime = hours + ':' + minutes + ' ' + ampm
            return (
                date.getMonth() +
                1 +
                '/' +
                date.getDate() +
                '/' +
                date.getFullYear() +
                '  ' +
                strTime
            )
        },

        formatDayOfWeek(value) {
        
        const daysOfWeek = [
            'Sunday',    // Index 1: Sunday
            'Monday',    // Index 2: Monday
            'Tuesday',   // Index 3: Tuesday
            'Wednesday', // Index 4: Wednesday
            'Thursday',  // Index 5: Thursday
            'Friday',    // Index 6: Friday
            'Saturday'   // Index 7: Saturday
        ];

       
        return daysOfWeek[value] || '';
    },
    getFrequencyType(value) {
        const { frequencies } =
            this.$store.getters['company/assetFrequencies']
        const obj = (frequencies || []).find(x => x.value == value)
        return obj ? obj.name : value == '0' ? 'One Off' : ''
    },

    async createSchedule() {
    let isError = false; 
    try {
        const { model } = this;
        let label = "";

       
        if (!model.name || !model.frequency || !model.order_template_id || !model.next_service_date) {
            throw new Error(this.$translate("schedule_error"));
        }

        if (this.model.frequency == "0") {
          const { next_service_date: nsd } = this.model;
          const weekday = new Date(nsd).getDay();
          this.$set(this.model, "service_day_of_week", weekday);
        }

        let service_time_of_day = model.service_time_of_day;
        
        if (service_time_of_day || service_time_of_day == 0) {
          let [hr, min] = (service_time_of_day || "").split(":");
          hr = hr || 0;
          min = min || 0;
          hr = isNaN(parseInt(hr)) ? 0 : parseInt(hr);
          min = isNaN(parseInt(min)) ? 0 : parseInt(min);
          service_time_of_day = min + 60 * hr;
        } else {
          service_time_of_day = null;
        }
        this.$set(this.model, "service_time_of_day", service_time_of_day);

        if (this.model.id) {
            label = this.$translate('updated');
            await this.$store.dispatch('assetScheduleStore/updateAssetSchedule', {
                schedule: this.model,
                assetId: this.assetId
            });
        } else {
            label = this.$translate('created');
            await this.$store.dispatch('assetScheduleStore/addAssetSchedule', {
                schedule: this.model,
                assetId: this.assetId
            });
        }

       
       

        this.scheduleCreated = true;

        let type_id = null
        if(this.crm){
            type_id = this.crmSettingValue.type_id;
        }
        await this.$store.dispatch('assetScheduleStore/fetchAssetSchedules', {  assetId : this.assetId,type_id});
       

        
        await this.doSearch();
        this.genericToast(
            this.componentName,
            label,
            'success',
            `${this.componentName} ${this.$translate('save_alert')}`
        );

      
    } catch (err) {
       
        this.doToast(
            this.$translate("error"),
            err.message,
            "danger"
        );
        isError = true; 
    } finally {
       
        if (!isError) {
            this.isModalVisible = false;
        }
    }
},


        async doSearch() {
          
            let {
                
                pagination: { page },
                
            } = this
          
          
            page = parseInt(page) || 1;

            this.tableLoading = true
            this.loaded = true;
            try{
                let type_id = null
                if(this.crm){
                    type_id = this.crmSettingValue?.type_id;
                }
              
                await this.$store.dispatch('assetScheduleStore/fetchAssetSchedules', {
                    assetId : this.assetId,
                    page ,
                    type_id
                })
            } catch(err) {
                console.log('fetch Error: ', err);
                this.doToast(this.$translate('error'), err.message, 'danger')
            } finally {
                this.tableLoading = false
                this.loaded = false;
            }
        },
        // deleteMessage(hash) {
        //     this.$store.dispatch('assetScheduleStore/delete', hash)
        //     this.genericToast(
        //         this.componentName,
        //         this.$translate('deleted'),
        //         'success',
        //         `${this.componentName} ${this.$translate('delete_alert')}`
        //     )
        //     this.$emit('success', this.componentName, this.$translate('deleted'))
        // },

        async deleteSchedule(scheduleId) {
            const confirmed = confirm('Are you sure you want to delete this schedule?');

            // Proceed only if the user confirms
            if (confirmed) {
                // const { model } = this;
                await this.$store.dispatch('assetScheduleStore/deleteAssetSchedule', {
                    schedule: scheduleId,
                    assetId: this.assetId
                });
                // Fetch the updated list of asset schedules
                await this.doSearch();
                this.genericToast(
                this.componentName,
                this.$translate('deleted'),
                'success',
                `${this.componentName} ${this.$translate('delete_alert')}`
            )
            }
        },

       
    },
}
</script>

<style>
.text-wrap {
    white-space: normal !important;
}

.created_at_class,
.user_id_class {
    width: 20% !important;
}

.id_class {
    width: 2% !important;
}

.actionButton_class {
    width: 8% !important;
}
</style>
